import { Box } from '@chakra-ui/react';
import { useForgotPassword } from '@frx/frx-react-context';
import { FC } from 'react';
import { useSearchParams } from 'react-router-dom';
import { RecoverIdentityForm } from '../../components';

export const RecoverIdentity: FC = () => {
  const { mutate: forgotPassword, isLoading, data } = useForgotPassword();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const isUsernameRecovery = type === 'username';

  const handleSubmit = (values: { email: string }) =>
    forgotPassword({
      email: values?.email,
      send_user_name: isUsernameRecovery,
    });

  return (
    <Box>
      <RecoverIdentityForm
        isLoading={isLoading}
        message={data?.message || ''}
        onSubmit={handleSubmit}
      />
    </Box>
  );
};
